import styled from 'styled-components'

export const ListItemCategoryTitle = styled.div(({ theme }) => ({
  ...theme.variants.caption.medium,
  textTransform: 'uppercase',
  borderBottom: `1px solid ${theme.colors.SDS_BRAND_COLOR_BORDER_WEAK_GREY}`,
  color: theme.colors.grey800,
  padding: `${theme.spacings.medium} 0 ${theme.spacings.medium} 0`,
  letterSpacing: `0.05em`,
}))
